import React from "react";

import PropTypes from "prop-types";
import decodeHTMLEntities from "core-web/utils/decodeHTMLEntities";
// import { productBreadcrumbs } from "core-web/utils/storm";
import { useTranslation } from "react-i18next";
import BreadcrumbsComponent from "theme/components/Breadcrumbs";
import { useSelector } from "react-redux";

const Breadcrumbs = ({ currentProduct = "", ...rest }) => {
    const { t } = useTranslation();

    let fullBreadcrumbs = [];
    const homeCrumb = {
        permalink: "/",
        title: t("breadcrumbs.home"),
    };

    /* Temp PDP breadcrumbs fix */
    const breadcrumbData = useSelector(({ page }) => page.data.product_in_categories || []);

    // get the highest length of the arrays in product_in_categories
    const highest = Math.max(...breadcrumbData.map((el) => el.length));

    // filter the array with the highest length & get the first one
    const categories = breadcrumbData.filter((el) => el.length === highest)?.[0] || [];

    const currentCrumb = { title: decodeHTMLEntities(currentProduct), permalink: "" };

    // const breadcrumbs = productBreadcrumbs(categories); //not used atm

    if (currentProduct) {
        fullBreadcrumbs = [homeCrumb, ...categories, currentCrumb];
    } else {
        fullBreadcrumbs = [...categories, currentCrumb];
    }

    return <BreadcrumbsComponent breadcrumbs={fullBreadcrumbs} isPDP {...rest} />;
};

Breadcrumbs.propTypes = {
    categories: PropTypes.array.isRequired,
    currentProduct: PropTypes.string,
};

export default Breadcrumbs;
